export default {"src":"/_next/static/media/card2.e90c944d.svg","height":215,"width":342,"blurWidth":0,"blurHeight":0};